import { jsonToCSV } from "react-papaparse";
import { convertCharCodeExportCSV } from "./convertCharCodeExportCSV";
import { zeroPadding } from "./zeroPadding";
import { exportFormats } from "./exportFormats";

export const createDownloadFileUrl = (
  rows: any[],
  charCode: "sjis" | "utf8" | "utf8bom",
  format: string
) => {
  const config = exportFormats[format];

  let outputString = "";

  if (config.type === "xml") {
    outputString = createPolyXML(rows);
  } else {
    if (format === "cloudbiz") {
      outputString = createCloudbizCSV(rows);
    } else {
      outputString = jsonToCSV(rows);
    }
    // BOM\u4ED8\u4E0E\u6761\u4EF6:
    //  - \u30E6\u30FC\u30B6\u30FC\u304C\u300CUTF-8\uFF08BOM\u4ED8\u304D\uFF09\u300D\u3092\u9078\u629E\u3057\u305F\u5834\u5408(utf8bom)
    //  - \u3082\u3057\u304F\u306F\u30D5\u30A9\u30FC\u30DE\u30C3\u30C8\u5074\u3067BOM\u5FC5\u9808\uFF08yealink/cloudbiz \u306F utf8\u56FA\u5B9A\u3067bom=true\uFF09\u306E\u5834\u5408
    const withBom =
      charCode === "utf8bom" || (config.bom && charCode === "utf8");
    if (withBom) {
      outputString = "\uFEFF" + outputString;
    }
  }

  const blob = convertCharCodeExportCSV(charCode, outputString);
  const date = new Date();
  const stamp =
    zeroPadding(date.getFullYear().toString(), 4) +
    zeroPadding((date.getMonth() + 1).toString(), 2) +
    zeroPadding(date.getDate().toString(), 2) +
    zeroPadding(date.getHours().toString(), 2) +
    zeroPadding(date.getMinutes().toString(), 2) +
    zeroPadding(date.getSeconds().toString(), 2);

  const extension = config.type === "xml" ? "xml" : "csv";

  const fileName = `contactAddress_${stamp}_${charCode}.${extension}`;
  const url = window.URL.createObjectURL(blob);

  return { url, fileName };
};

export const createPolyXML = (rows: any[]) => {
  let xml = `<?xml version="1.0" encoding="UTF-8"?>\n<PolyContacts>\n`;

  rows.forEach((item) => {
    xml += `  <Contact>\n`;
    Object.keys(item).forEach((key) => {
      xml += `    <${key}>${item[key]}</${key}>\n`;
    });
    xml += `  </Contact>\n`;
  });

  xml += `</PolyContacts>`;
  return xml;
};

const createCloudbizCSV = (rows: any[]) => {
  const config = exportFormats["cloudbiz"];

  const headerLine = config.headers.join(config.delimiter);

  const dataLines = rows.map((row) => {
    const cells = config.headers.map((header) => {
      const raw = (row as any)[header] ?? "";
      const value = String(raw ?? "").trim();

      switch (header) {
        case "名称":
        case "名称カナ": {
          const normalized = value.replace(/"/g, '""');
          return `"${normalized}"`;
        }
        case "短縮番号":
        case "ワンタッチ番号": {
          return value;
        }

        case "内線/外線": {
          return value;
        }

        case "電話番号": {
          if (!value) return "";
          const normalized = value.replace(/['"]/g, "").trim();
          if (!normalized) return "";
          return `'${normalized}`;
        }

        case "備考": {
          const normalized = value.replace(/"/g, '""');
          return `"${normalized}"`;
        }

        default: {
          return value;
        }
      }
    });

    return cells.join(config.delimiter);
  });

  return [headerLine, ...dataLines].join("\n");
};

